import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Calendar, ChevronRight, GraduationCap, Heart, Mail, ExternalLink, Trophy, Clock, CreditCard, CheckCircle, Phone, User, MapPin, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { GrasrotandelenBanner } from '../components/GrasrotandelenBanner';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

import i18n from '../i18n';
const t = (k, o) => i18n.t(k, o);

// Team data structure with staff information
const getteams = () => ({
  voksen: [
    { 
      id: 'a-lag-menn', 
      name: 'A-lag Menn', 
      division: t('pg.Soccer.f9c382'), 
      description: t('pg.Soccer.b51e7e'), 
      image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Nickolas Paynter', phone: '+47 907 39 749', email: 'nickolas.paynter@veitvet-sportsklubb.no' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Lisa Marie Rognlien', phone: '+47 479 04 791', email: 'lisa.rognlien@gmail.com' }
        ]
      }
    },
    { 
      id: 'a-lag-kvinner', 
      name: 'A-lag Kvinner', 
      division: t('pg.Soccer.c3e2bd'), 
      description: t('pg.Soccer.ae8eb1'), 
      image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Arild Nybakk', phone: '+47 913 50 276', email: 'arildnybakk@gmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Maj-Lis Kesti', phone: '+47 992 78 636', email: 'majlisk@gmail.com' },
          { role: t('pg.Soccer.3cccaf'), name: 'Maria Pedersen Gåshopen', phone: '+47 454 76 008', email: 'mpgaashopen@hotmail.no' },
          { role: t('pg.Soccer.3cccaf'), name: 'Thanushia Thiyagarajah' }
        ]
      }
    },
    { 
      id: 'oldboys', 
      name: 'Oldboys', 
      division: t('pg.Soccer.c3e2bd'), 
      age: '34+', 
      description: t('pg.Soccer.1f2205'), 
      image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Fabian Castro', phone: '+47 454 87 870', email: 'fcastro989@yahoo.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'André Fayen', phone: '+47 932 49 726', email: 'andrefayen@gmail.com' }
        ]
      }
    },
  ],
  ungdom: [
    { 
      id: 'g19', 
      name: 'G19', 
      yearBorn: '2008-2009', 
      description: t('pg.Soccer.5495e4'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Eric Alfred Ma Gloire Kouoh', phone: '+47 960 14 393', email: 'kouoheric@hotmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Lisa Marie Rognlien', phone: '+47 479 04 791', email: 'lisa.rognlien@gmail.com' }
        ]
      }
    },
    { 
      id: 'g14', 
      name: 'G14', 
      yearBorn: '2012', 
      description: t('pg.Soccer.53e710'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Harald Stormoen', phone: '+47 959 19 591', email: 'haraldstormoen1@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Marcus Rognlien', phone: '+47 986 82 956', email: 'kristiansenrognlienmarcus@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Ridwan Dahir Dahir Ahmed', phone: '+47 408 40 265', email: 'ridwaan596@icloud.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Michal Stefanczak', phone: '+47 416 31 255', email: 'michalst@gmail.com' }
        ]
      }
    },
    { 
      id: 'g13', 
      name: 'G13', 
      yearBorn: '2013', 
      description: t('pg.Soccer.c6e370'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Eric Alfred Ma Gloire Kouoh', phone: '+47 960 14 393', email: 'kouoheric@hotmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Aristoteles Lopes Gomes', phone: '+47 406 40 641', email: 'arisgomes1@hotmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Sven Anders Sjøblom Stensø', phone: '+47 916 49 209', email: 'anders.sven.sjoblom@gmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Ane Sjøblom Stensø', phone: '+47 452 84 958', email: 'anestenso@gmail.com' },
          { role: t('pg.Soccer.3cccaf'), name: 'Michal Stefanczak', phone: '+47 416 31 255', email: 'michalst@gmail.com' }
        ]
      }
    },
  ],
  barn: [
    { 
      id: 'g12', 
      name: 'G12', 
      yearBorn: '2014', 
      description: t('pg.Soccer.d059d7'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Bjarne Kristoffersen', phone: '+47 952 87 110', email: 'bjarne.kristoffersen@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Shakho Botan', phone: '+47 934 57 464', email: 'shakhobotan@hotmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Oda Sjøvoll', phone: '+47 971 11 678', email: 'oda.sjovoll@gmail.com' }
        ]
      }
    },
    { 
      id: 'j12', 
      name: 'J12', 
      yearBorn: '2014', 
      description: t('pg.Soccer.ec0ca0'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Lars Hage', phone: '+47 975 17 808', email: 'hagelars@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Stig Jacobsen', phone: '+47 976 81 569', email: 'stigjacobsen.65@gmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'André Rustad De Brisis', phone: '+47 936 44 327', email: 'andre.brisis@gmail.com' },
          { role: t('pg.Soccer.fcba41'), name: 'Susanne Brovold Hvidsten', phone: '+47 402 03 355', email: 'susannebrovold@hotmail.com' }
        ]
      }
    },
    { 
      id: 'g11', 
      name: 'G11', 
      yearBorn: '2015', 
      description: t('pg.Soccer.04cc4d'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Adrian May', phone: '+47 944 74 401', email: 'adrian.may21@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Waqas Amin', phone: '+47 415 48 919', email: 'waqasamin786@hotmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Halim Saghir', phone: '+47 959 64 560', email: 'halim.saghir@gmail.com' },
          { role: t('pg.Soccer.3cccaf'), name: 'Michal Stefanczak', phone: '+47 416 31 255', email: 'michalst@gmail.com' },
          { role: t('pg.Soccer.de7aba'), name: 'Nina Joy Borja Pucyutan', phone: '+47 967 20 597', email: 'niajoy_12@yahoo.com' }
        ]
      }
    },
    { 
      id: 'g10', 
      name: 'G10', 
      yearBorn: '2016', 
      description: t('pg.Soccer.13d0c2'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Alexander Fjeld', phone: '+47 978 98 471', email: 'alexanderfjeld@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Helge Malmbekk', phone: '+47 970 13 964', email: 'malmbekk@gmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Kristine Eikenes', phone: '+47 922 52 352', email: 'eikenes.kristine@gmail.com' },
          { role: t('pg.Soccer.de7aba'), name: 'Kaja Pauck Øglund' },
          { role: t('pg.Soccer.de7aba'), name: 'Vesna Cakarevic' }
        ]
      }
    },
    { 
      id: 'g9', 
      name: 'G9', 
      yearBorn: '2017', 
      description: t('pg.Soccer.018292'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Sabahudin Osmanovic', phone: '+47 463 52 126', email: 'sabaoslo9@gmail.com' }
        ],
        leaders: []
      }
    },
    { 
      id: 'g8', 
      name: 'G8', 
      yearBorn: '2018', 
      description: t('pg.Soccer.c808ea'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [],
        leaders: []
      }
    },
    { 
      id: 'j8', 
      name: 'J8', 
      yearBorn: '2018', 
      description: t('pg.Soccer.5b3761'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Kjetil Aske-Fredriksen', phone: '+47 414 02 65', email: 'kjetilwfredriksen@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Sverre Bolstad', phone: '+47 464 44 380', email: 'sverrebolstad75@gmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Per Atle Aaslid', phone: '+47 995 23 755', email: 'per_a_aaslid@hotmail.com' }
        ]
      }
    },
    { 
      id: 'g7', 
      name: 'G7', 
      yearBorn: '2019', 
      description: t('pg.Soccer.d56c1a'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Simen Aasheim Johansen', phone: '+47 452 73 822', email: 'simenaaj@hotmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Christian Steinsholm', phone: '+47 957 91 740', email: 'csteinsholm@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Mahadevan Jegatheesan', phone: '+47 463 87 616', email: 'jegatheesan.mahadevan@gmail.com' }
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Robin Granum Nguyen', phone: '+47 955 57 552', email: 'robin.granum@hotmail.com' },
          { role: t('pg.Soccer.de7aba'), name: 'Karina Hornslien', phone: '+47 977 19 254', email: 'karina.hornslien@gmail.com' }
        ]
      }
    },
    { 
      id: 'j7', 
      name: 'J7', 
      yearBorn: '2019', 
      description: t('pg.Soccer.20c100'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'André Fayen', phone: '+47 932 49 726', email: 'andrefayen@gmail.com' },
          { role: t('pg.Soccer.b11390'), name: 'Stein-Erik Nyheim Jacobsen', phone: '+47 994 84 526', email: '' },
          { role: t('pg.Soccer.175eef'), name: 'Sigbjørn Hølmebakk Mangseth', phone: '+47 915 97 149', email: 'mangseth.s@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Eirik Dahl Linnsund', phone: '+47 415 43 831', email: 'elinnsund@gmail.com' }
        ],
        leaders: []
      }
    },
    { 
      id: 'g6', 
      name: 'G6', 
      yearBorn: '2020', 
      description: t('pg.Soccer.fe7e74'), 
      image: 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400',
      staff: {
        coaches: [
          { role: t('pg.Soccer.b11390'), name: 'Mounir Achalhi', phone: '+47 917 45 498', email: 'monir@live.no' },
          { role: t('pg.Soccer.175eef'), name: 'Frida Sigstad', phone: '+47 481 42 870', email: 'frida.sigstad@gmail.com' },
          { role: t('pg.Soccer.175eef'), name: 'Emanuel Rodriges Lima', phone: '+47 938 04 536', email: 'jalim@online.no' },
        ],
        leaders: [
          { role: t('pg.Soccer.3cccaf'), name: 'Martin Møen Bergland', phone: '+47 417 87 592', email: 'bergis14@gmail.com' },
        ]
      }
    },
  ],
});

// Staff Contact Card Component
const StaffContact = ({ person }) => (
  <div className="bg-slate-100/50 dark:bg-slate-700/50 rounded-lg p-3">
    <p className="text-green-500 text-xs font-medium uppercase tracking-wider mb-1">{person.role}</p>
    <p className="text-slate-900 dark:text-white font-medium text-sm">{person.name || <span className="text-slate-400 dark:text-slate-500 italic">{t('pg.Soccer.78ca14')}</span>}</p>
    <div className="mt-2 space-y-1">
      {person.phone ? (
        <a href={`tel:${person.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 text-slate-500 dark:text-slate-400 hover:text-green-500 dark:hover:text-green-400 text-xs transition-colors" aria-label={`Ring ${person.name}`}>
          <Phone className="w-3 h-3" aria-hidden="true" />
          {person.phone}
        </a>
      ) : (
        <p className="flex items-center gap-2 text-slate-400 dark:text-slate-500 text-xs italic">
          <Phone className="w-3 h-3" aria-hidden="true" />
          {t('pg.Soccer.f2b4d0')}
        </p>
      )}
      {person.email ? (
        <a href={`mailto:${person.email}`} className="flex items-center gap-2 text-slate-500 dark:text-slate-400 hover:text-green-500 dark:hover:text-green-400 text-xs transition-colors break-all" aria-label={`Send e-post til ${person.name}`}>
          <Mail className="w-3 h-3 flex-shrink-0" aria-hidden="true" />
          {person.email}
        </a>
      ) : (
        <p className="flex items-center gap-2 text-slate-400 dark:text-slate-500 text-xs italic">
          <Mail className="w-3 h-3 flex-shrink-0" aria-hidden="true" />
          {t('pg.Soccer.a28136')}
        </p>
      )}
      {person.address && (
        <p className="flex items-start gap-2 text-slate-500 dark:text-slate-400 text-xs">
          <MapPin className="w-3 h-3 flex-shrink-0 mt-0.5" aria-hidden="true" />
          <span>{person.address}</span>
        </p>
      )}
    </div>
  </div>
);

// Senior Team Card with Staff
const SeniorTeamCard = ({ team }) => (
  <div
    data-testid={`team-card-${team.id}`}
    className="bg-white dark:bg-slate-800 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 hover:border-green-500/50 transition-all duration-300"
  >
    <div className="aspect-video relative overflow-hidden">
      <img
        src={team.image}
        alt={`${team.name} - Veitvet Sportsklubb fotballag`}
        loading="lazy"
        className="w-full h-full object-cover"
      />
      <div className="absolute top-3 left-3 flex gap-2">
        <span className="bg-green-500 text-white text-xs font-bold px-2 py-1 rounded uppercase">
          {team.name}
        </span>
        {team.division && (
          <span className="bg-slate-100 text-slate-900 text-xs font-bold px-2 py-1 rounded">
            {team.division}
          </span>
        )}
        {team.yearBorn && (
          <span className="bg-slate-100 text-slate-900 text-xs font-bold px-2 py-1 rounded">
            {t('pg.Soccer.d1a8db')} {team.yearBorn}
          </span>
        )}
      </div>
    </div>
    <div className="p-5">
      <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-1">
        {team.name}
        {team.age && <span className="text-slate-500 dark:text-slate-400 font-normal text-base ml-2">({team.age})</span>}
      </h3>
      <p className="text-sm text-slate-500 dark:text-slate-400 mb-4">{team.description}</p>
      
      {team.staff && (
        <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
          <h4 className="text-sm font-bold text-slate-900 dark:text-white mb-3 flex items-center gap-2">
            <User className="w-4 h-4 text-green-500" aria-hidden="true" />
            {t('pg.Soccer.3e719f')}
          </h4>
          <div className="space-y-2">
            {team.staff.coaches.map((coach, idx) => (
              <StaffContact key={`coach-${idx}`} person={coach} />
            ))}
            {team.staff.leaders.map((leader, idx) => (
              <StaffContact key={`leader-${idx}`} person={leader} />
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
);

const TeamCard = ({ team, showYear = true }) => (
  <div
    data-testid={`team-card-${team.id}`}
    className="group bg-white dark:bg-slate-800 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 hover:border-green-500/50 transition-all duration-300"
  >
    <div className="aspect-video relative overflow-hidden">
      <img
        src={team.image}
        alt={`${team.name} - Veitvet Sportsklubb fotballag`}
        loading="lazy"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute top-3 left-3 flex gap-2">
        <span className="bg-green-500 text-white text-xs font-bold px-2 py-1 rounded uppercase">
          {team.name}
        </span>
        {team.division && (
          <span className="bg-slate-100 text-slate-900 text-xs font-bold px-2 py-1 rounded">
            {team.division}
          </span>
        )}
      </div>
    </div>
    <div className="p-4">
      <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-1 group-hover:text-green-500 transition-colors">
        {team.name}
        {team.age && <span className="text-slate-500 dark:text-slate-400 font-normal ml-2">({team.age})</span>}
      </h3>
      {showYear && team.yearBorn && (
        <p className="text-green-500 text-sm mb-2">{t('pg.Soccer.d1a8db')} {team.yearBorn}</p>
      )}
      <p className="text-sm text-slate-500 dark:text-slate-400">{team.description}</p>
    </div>
  </div>
);

const AcademySection = () => (
  <div className="space-y-8">
    {/* Academy Hero */}
    <div className="bg-gradient-to-r from-green-500/20 to-transparent rounded-2xl p-8 border border-green-500/30">
      <div className="flex items-center gap-3 mb-4">
        <GraduationCap className="w-10 h-10 text-green-500" aria-hidden="true" />
        <div>
          <h2 className="text-3xl font-bold text-slate-900 dark:text-white">{t('pg.Soccer.703573')}</h2>
          <p className="text-green-500 font-medium">{t('pg.Soccer.64cc67')}</p>
        </div>
      </div>
      <p className="text-slate-600 dark:text-slate-300 text-lg max-w-3xl mb-4">
        {t('pg.Soccer.446ff4')}
      </p>
      <p className="text-slate-600 dark:text-slate-300 max-w-3xl">
        {t('pg.Soccer.ddbb61')}
      </p>

      {/* Read more buttons */}
      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <Link to="/fotball/barneakademi" data-testid="read-more-barneakademi" className="inline-flex items-center justify-center gap-2 bg-white dark:bg-slate-800 border-2 border-green-500/40 hover:border-green-500 text-slate-900 dark:text-white px-5 py-3 rounded-xl font-bold transition-all hover:shadow-md">
          {t('pg.Soccer.07726b')}
          <ArrowRight className="w-4 h-4 text-green-500" />
        </Link>
        <Link to="/fotball/ungdomsakademi" data-testid="read-more-ungdomsakademi" className="inline-flex items-center justify-center gap-2 bg-white dark:bg-slate-800 border-2 border-green-500/40 hover:border-green-500 text-slate-900 dark:text-white px-5 py-3 rounded-xl font-bold transition-all hover:shadow-md">
          {t('pg.Soccer.2d9f27')}
          <ArrowRight className="w-4 h-4 text-green-500" />
        </Link>
      </div>
    </div>

    {/* Hva står vi for? */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.d4e38a')}</h3>
      <p className="text-slate-600 dark:text-slate-300 mb-4">{t('pg.Soccer.e6d86e')}</p>
      <ul className="space-y-2 mb-4">
        {[
          t('pg.Soccer.db1a49'),
          t('pg.Soccer.819cc7'),
          t('pg.Soccer.8b2e71'),
          t('pg.Soccer.3eb6ae'),
          t('pg.Soccer.cb4023'),
        ].map((item) => (
          <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
            <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <p className="text-slate-600 dark:text-slate-300 italic">
        {t('pg.Soccer.3ad7b8')}
      </p>
    </div>

    {/* Hvordan foregår treningene? */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <div className="flex items-center gap-3 mb-4">
        <Clock className="w-7 h-7 text-green-500" aria-hidden="true" />
        <h3 className="text-2xl font-bold text-slate-900 dark:text-white">{t('pg.Soccer.2604cf')}</h3>
      </div>
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t('pg.Soccer.a7a9d2')}
      </p>
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t('pg.Soccer.66ddd0')}
      </p>
      <p className="text-slate-600 dark:text-slate-300">
        {t('pg.Soccer.c09c07')}
      </p>
    </div>

    {/* Vår filosofi */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.692ead')}</h3>
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t('pg.Soccer.3886bc')}
      </p>
      <p className="text-slate-600 dark:text-slate-300 mb-4">
        {t('pg.Soccer.5613fa')}
      </p>
      <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-3">{t('pg.Soccer.2ec391')}</h4>
      <ul className="space-y-2 mb-4">
        {[
          t('pg.Soccer.d9a91b'),
          t('pg.Soccer.804a17'),
          t('pg.Soccer.50be1f'),
          t('pg.Soccer.acc387'),
          t('pg.Soccer.71ec85'),
          t('pg.Soccer.4e06b0'),
        ].map((item) => (
          <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
        <p className="text-slate-700 dark:text-slate-200 font-medium">
          {t('pg.Soccer.f02a75')}
        </p>
      </div>
    </div>

    {/* Innhold i treningene */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.c08581')}</h3>
      <p className="text-slate-600 dark:text-slate-300 mb-4">
        {t('pg.Soccer.9c252f')}
      </p>
      <div className="grid sm:grid-cols-2 gap-3 mb-4">
        {[
          t('pg.Soccer.3d2a4f'),
          t('pg.Soccer.7ebd5c'),
          t('pg.Soccer.cf1a2d'),
          t('pg.Soccer.a5f1bf'),
          t('pg.Soccer.1b9e32'),
        ].map((item) => (
          <div key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300 bg-slate-50 dark:bg-slate-700/40 rounded-lg p-3">
            <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
            <span className="text-sm">{item}</span>
          </div>
        ))}
      </div>
      <p className="text-slate-600 dark:text-slate-300 italic">
        {t('pg.Soccer.308c2a')}
      </p>
    </div>

    {/* Hvem kan delta? */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.1f2b7d')}</h3>
      <p className="text-slate-600 dark:text-slate-300 mb-4">{t('pg.Soccer.b1c3ce')}</p>
      <ul className="space-y-2 mb-4">
        {[
          t('pg.Soccer.61b350'),
          t('pg.Soccer.996665'),
          t('pg.Soccer.efd7f5'),
        ].map((item) => (
          <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
            <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <p className="text-slate-600 dark:text-slate-300">
        {t('pg.Soccer.4811f6')}
      </p>
    </div>

    {/* For spillere fra andre klubber */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.7e4399')}</h3>
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t('pg.Soccer.4583d5')}
      </p>
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t('pg.Soccer.a3c58c')}
      </p>
      <p className="text-slate-600 dark:text-slate-300">
        {t('pg.Soccer.2486ea')}
      </p>
    </div>

    {/* Våre trenere */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.f596bd')}</h3>
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t('pg.Soccer.d97f3f')}
      </p>
      <p className="text-slate-600 dark:text-slate-300">
        {t('pg.Soccer.7a1d5b')}
      </p>
    </div>

    {/* Pris */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <div className="flex items-center gap-3 mb-4">
        <CreditCard className="w-7 h-7 text-green-500" aria-hidden="true" />
        <h3 className="text-2xl font-bold text-slate-900 dark:text-white">{t('pg.Soccer.62f536')}</h3>
      </div>
      <p className="text-slate-600 dark:text-slate-300 mb-5">
        {t('pg.Soccer.93b4e5')}
      </p>
      <p className="text-slate-500 dark:text-slate-400 text-sm mb-4">
        {t('pg.Soccer.511dc5')}
      </p>
      <div className="grid sm:grid-cols-2 gap-4 mb-5">
        <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-5">
          <p className="text-slate-500 dark:text-slate-400 text-sm uppercase tracking-wider mb-1">{t('pg.Soccer.a04402')}</p>
          <p className="text-3xl font-bold text-green-500">kr 3 000</p>
          <p className="text-slate-400 dark:text-slate-500 text-xs mt-1">{t('pg.Soccer.d6c49b')}</p>
        </div>
        <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-5">
          <p className="text-slate-500 dark:text-slate-400 text-sm uppercase tracking-wider mb-1">{t('pg.Soccer.a33629')}</p>
          <p className="text-3xl font-bold text-green-500">kr 4 000</p>
          <p className="text-slate-400 dark:text-slate-500 text-xs mt-1">{t('pg.Soccer.d6c49b')}</p>
        </div>
      </div>
      <p className="text-slate-500 dark:text-slate-400 text-sm italic">
        {t('pg.Soccer.d9f818')}
      </p>
    </div>

    {/* Påmelding */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.Soccer.6831ce')}</h3>
      <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 mb-5">
        <p className="text-slate-700 dark:text-slate-200 font-medium">
          {t('pg.Soccer.c2476d')}
        </p>
      </div>
      <p className="text-slate-600 dark:text-slate-300 mb-4">{t('pg.Soccer.754425')}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <a
          href="https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-6-12-ar-202627-374765"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="academy-signup-children"
          aria-label={t('pg.Soccer.5193ed')}
          className="group block bg-green-500/10 border-2 border-green-500/30 hover:border-green-500 rounded-xl p-5 transition-all"
        >
          <p className="text-xs text-green-600 dark:text-green-400 font-bold uppercase tracking-wider mb-1">{t('pg.Soccer.ee088d')}</p>
          <p className="text-xl font-bold text-slate-900 dark:text-white mb-2 group-hover:text-green-500 transition-colors">{t('pg.Soccer.a04402')}</p>
          <span className="inline-flex items-center text-green-500 font-medium text-sm">
            {t('pg.Soccer.82558b')} <ExternalLink className="ml-2 w-4 h-4" aria-hidden="true" />
          </span>
        </a>
        <a
          href="https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-13-16-ar-202627-510222"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="academy-signup-youth"
          aria-label={t('pg.Soccer.83e0f2')}
          className="group block bg-green-500/10 border-2 border-green-500/30 hover:border-green-500 rounded-xl p-5 transition-all"
        >
          <p className="text-xs text-green-600 dark:text-green-400 font-bold uppercase tracking-wider mb-1">{t('pg.Soccer.339433')}</p>
          <p className="text-xl font-bold text-slate-900 dark:text-white mb-2 group-hover:text-green-500 transition-colors">{t('pg.Soccer.a33629')}</p>
          <span className="inline-flex items-center text-green-500 font-medium text-sm">
            {t('pg.Soccer.82558b')} <ExternalLink className="ml-2 w-4 h-4" aria-hidden="true" />
          </span>
        </a>
      </div>
    </div>

    {/* Kontakt oss */}
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
      <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-3">{t('pg.Soccer.8d1c6b')}</h4>
      <div className="space-y-2">
        <a
          href="mailto:fotballakademi@veitvet-sportsklubb.no"
          className="inline-flex items-center gap-2 text-green-500 hover:underline"
          aria-label="Send e-post til fotballakademi@veitvet-sportsklubb.no"
        >
          <Mail className="w-5 h-5" aria-hidden="true" />
          fotballakademi@veitvet-sportsklubb.no
        </a>
        <a
          href="tel:+4790083520"
          className="flex items-center gap-2 text-green-500 hover:underline"
          aria-label={t('pg.Soccer.759490')}
        >
          <Phone className="w-5 h-5" aria-hidden="true" />
          900 83 520
        </a>
      </div>
    </div>
  </div>
);

export const Soccer = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('alle');

  const totalTeams = getteams().voksen.length + getteams().ungdom.length + getteams().barn.length;

  return (
    <div data-testid="soccer-page">
      <SEO 
        title={t('pg.Soccer.10066f')} 
        description={t('pg.Soccer.b76b95')}
      />
      {/* Hero Section */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1920&q=80"
            alt={t('pg.Soccer.2203ca')}
            loading="eager"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/70 to-transparent" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <p className="text-green-400 font-medium uppercase tracking-widest mb-4">{t('soccer.department', 'Fotballavdeling')}</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter text-white mb-6">
            {t('soccer.heroTitle')} <span className="text-green-400">{t('soccer.heroTitle2')}</span>
          </h1>
          <p className="text-xl text-white/90 max-w-2xl">
            {t('soccer.heroDescription', { count: totalTeams })}
          </p>
        </div>
      </section>

      {/* Club Stats */}
      <section className="py-10 bg-white dark:bg-slate-800 border-y border-slate-200 dark:border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <p className="text-3xl font-bold text-green-500">{totalTeams}</p>
              <p className="text-slate-500 dark:text-slate-400 text-sm">{t('soccer.totalTeams', 'Lag totalt')}</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-green-500">125+</p>
              <p className="text-slate-500 text-sm">{t('soccer.academyPlayers', 'Akademispillere')}</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-green-500">50+</p>
              <p className="text-slate-500 text-sm">{t('soccer.volunteers', 'Frivillige')}</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-green-500">1955</p>
              <p className="text-slate-500 text-sm">{t('about.founded', 'Grunnlagt')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section - Vår fotballbane */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <p className="text-green-500 font-medium uppercase tracking-widest mb-4">{t('soccer.viewPitch', 'Se vår bane')}</p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tighter text-slate-900 dark:text-white mb-4">
              {t('soccer.pitchName', 'VEITVET KUNSTGRESSBANE')}
            </h2>
            <p className="text-slate-500 dark:text-slate-400">
              {t('soccer.pitchDescription', 'Ta en titt på vår flotte kunstgressbane hvor vi trener og spiller kamper')}
            </p>
          </div>
          <div className="relative w-full aspect-video rounded-2xl overflow-hidden border border-slate-200 shadow-2xl shadow-green-500/5">
            <iframe
              data-testid="football-pitch-video"
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/roP_4LUOCYI"
              title={t('pg.Soccer.9c6b86')}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* Teams Section with Tabs */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <p className="text-green-500 font-medium uppercase tracking-widest mb-4">{t('home.explore', 'Utforsk')}</p>
            <h2 className="text-4xl font-bold tracking-tighter text-slate-900 dark:text-white mb-6">
              {t('nav.football', 'FOTBALL')}
            </h2>
            <Link to="/fotball/treningstider" data-testid="treningstider-cta-btn">
              <Button className="bg-green-500 text-white font-bold uppercase tracking-wider px-7 py-5 hover:bg-green-600 shadow-md whitespace-normal h-auto max-w-full">
                <Clock className="w-4 h-4 mr-2" />
                {t('pg.Soccer.5b1377')}
                <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>

          {/* Main Category Tabs */}
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="w-full flex flex-wrap justify-center gap-2 bg-transparent h-auto mb-8">
              <TabsTrigger 
                value="alle" 
                data-testid="tab-alle"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-white bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider"
              >
                {t('soccer.allTeams')}
              </TabsTrigger>
              <TabsTrigger 
                value="voksen" 
                data-testid="tab-voksen"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-white bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider"
              >
                {t('soccer.adult')}
              </TabsTrigger>
              <TabsTrigger 
                value="ungdom" 
                data-testid="tab-ungdom"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-white bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider"
              >
                {t('soccer.youth')}
              </TabsTrigger>
              <TabsTrigger 
                value="barn" 
                data-testid="tab-barn"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-white bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider"
              >
                {t('soccer.children')}
              </TabsTrigger>
              <TabsTrigger 
                value="akademi" 
                data-testid="tab-akademi"
                className="data-[state=active]:bg-green-500 data-[state=active]:text-white bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-white px-6 py-3 rounded-lg font-bold uppercase tracking-wider flex items-center gap-2"
              >
                <GraduationCap className="w-4 h-4" />
                {t('soccer.academy')}
              </TabsTrigger>
            </TabsList>

            {/* All Teams */}
            <TabsContent value="alle" className="space-y-12">
              {/* Voksen */}
              <div>
                <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-3">
                  <Trophy className="w-6 h-6 text-green-500" />
                  {t('soccer.adult')}
                </h3>
                <div className="grid md:grid-cols-3 gap-6">
                  {getteams().voksen.map((team) => (
                    <SeniorTeamCard key={team.id} team={team} />
                  ))}
                </div>
              </div>

              {/* Ungdom */}
              <div>
                <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-3">
                  <Users className="w-6 h-6 text-green-500" />
                  {t('soccer.youth')}
                </h3>
                <div className="grid md:grid-cols-3 gap-6">
                  {getteams().ungdom.map((team) => (
                    <SeniorTeamCard key={team.id} team={team} />
                  ))}
                </div>
              </div>

              {/* Barn */}
              <div>
                <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-3">
                  <Heart className="w-6 h-6 text-green-500" />
                  {t('soccer.children')}
                </h3>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {getteams().barn.map((team) => (
                    team.staff ? (
                      <SeniorTeamCard key={team.id} team={team} />
                    ) : (
                      <TeamCard key={team.id} team={team} />
                    )
                  ))}
                </div>
              </div>
            </TabsContent>

            {/* Voksen Tab */}
            <TabsContent value="voksen">
              <div className="grid md:grid-cols-3 gap-6">
                {getteams().voksen.map((team) => (
                  <SeniorTeamCard key={team.id} team={team} />
                ))}
              </div>
            </TabsContent>

            {/* Ungdom Tab */}
            <TabsContent value="ungdom">
              <div className="grid md:grid-cols-3 gap-6">
                {getteams().ungdom.map((team) => (
                  <SeniorTeamCard key={team.id} team={team} />
                ))}
              </div>
            </TabsContent>

            {/* Barn Tab */}
            <TabsContent value="barn">
              <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {getteams().barn.map((team) => (
                  team.staff ? (
                    <SeniorTeamCard key={team.id} team={team} />
                  ) : (
                    <TeamCard key={team.id} team={team} />
                  )
                ))}
              </div>
            </TabsContent>

            {/* Academy Tab */}
            <TabsContent value="akademi">
              <AcademySection />
            </TabsContent>
          </Tabs>
        </div>
      </section>

      {/* Volunteers Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-y border-slate-200 dark:border-slate-700">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center gap-4 text-center">
            <Heart className="w-8 h-8 text-green-500" />
            <div>
              <p className="text-2xl font-bold text-slate-900 dark:text-white">{t('pg.Soccer.0be83e')}</p>
              <p className="text-slate-500 dark:text-slate-400">{t('pg.Soccer.6ff1e6')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Join CTA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold tracking-tighter text-slate-900 mb-4">
            {t('pg.Soccer.c35fcd')}
          </h2>
          <p className="text-slate-500 text-lg mb-8">
            {t('pg.Soccer.234187')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="https://app.hoopit.io/join/veitvet-sportsklubb-532465/open?skipWelcome=true&push=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-green-500 text-white font-bold uppercase tracking-wider px-8 py-6 hover:bg-green-500/90">
                {t('pg.Soccer.8df769')}
                <ExternalLink className="ml-2 w-5 h-5" />
              </Button>
            </a>
            <Link to="/contact">
              <Button variant="outline" className="border-slate-300 text-slate-900 uppercase tracking-wider px-8 py-6 hover:bg-slate-100 dark:bg-slate-700">
                {t('pg.Soccer.8d1c6b')}
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Grasrotandelen Banner */}
      <GrasrotandelenBanner />
    </div>
  );
};

export default Soccer;
